import menu from '@/assets/js/menu'
import localStorageHelpers from '@/helpers/localStorage'

export default {
  updateRememberMe(state, value) {
    state.rememberMe = value
  },
  updateLogin(state, login) {
    state.login = login
  },
  updatePassword(state, password) {
    state.password = password
  },
  updateIsError(state, isError) {
    state.isError = isError
  },
  updateToken(state, token) {
    localStorageHelpers.__setToken(token)
    state.menu = menu
  },
  resetForm(state) {
    state.login = null
    state.password = null
    state.rememeberMe = false
  },
}
